import { useEffect } from 'react';

import { useStableCallback } from 'core/hooks/useStableCallback';

export default function useKeyboard(
  onAddSym: (sym: string) => void,
  onBackspace: () => void,
  replay: () => void,
  disabled: boolean
) {
  const onKeyUp = useStableCallback((evt: KeyboardEvent): void => {
    if (disabled || evt.ctrlKey || evt.altKey || evt.shiftKey || evt.metaKey) {
      return;
    }

    const [, , digit = ''] = evt.code.match(/(Digit|Numpad)(\d+)/) ?? [];
    if (digit.length) {
      onAddSym(digit);
    } else if (evt.code === 'Backspace') {
      onBackspace();
    } else if (evt.code === 'Space') {
      replay();
    }
  });

  useEffect(() => {
    document.addEventListener('keyup', onKeyUp);
    return () => document.removeEventListener('keyup', onKeyUp);
  }, []);
}
